import { render } from "./Featured.vue?vue&type=template&id=a027feec&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"

import "./Featured.vue?vue&type=style&index=0&id=a027feec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a027feec"

export default script